/**
 * Replace https to http if local
 */

const adjustUrlToEnv = (url?: string) => {
  if (!url) return;
  
  const isLocal = window.location.href.includes(":3000");

  return isLocal ? url.replace("https", "http") : url;
};

export default adjustUrlToEnv;
